import {
  GET_DOCUMENT_REQUESTS,
  GET_DOCUMENT_REQUESTS_FAIL,
  GET_DOCUMENT_REQUESTS_SUCCESS,
  ADD_NEW_DOCUMENT_REQUEST,
  ADD_DOCUMENT_REQUEST_SUCCESS,
  ADD_DOCUMENT_REQUEST_FAIL,
  UPDATE_DOCUMENT_REQUEST,
  UPDATE_DOCUMENT_REQUEST_SUCCESS,
  UPDATE_DOCUMENT_REQUEST_FAIL,
  DELETE_DOCUMENT_REQUEST,
  DELETE_DOCUMENT_REQUEST_SUCCESS,
  DELETE_DOCUMENT_REQUEST_FAIL,
  
} from "./actionTypes";

export const getDocumentRequests = () => ({
  type: GET_DOCUMENT_REQUESTS,
})

export const getDocumentRequestsSuccess = documentRequests => ({
  type: GET_DOCUMENT_REQUESTS_SUCCESS,
  payload: documentRequests,
})

export const getDocumentRequestsFail = error => ({
  type: GET_DOCUMENT_REQUESTS_FAIL,
  payload: error,
})

export const addNewDocumentRequest = data => ({
  type: ADD_NEW_DOCUMENT_REQUEST,
  payload: data,
})

export const addDocumentRequestSuccess = documentRequest => ({
  type: ADD_DOCUMENT_REQUEST_SUCCESS,
  payload: documentRequest,
})

export const addDocumentRequestFail = error => ({
  type: ADD_DOCUMENT_REQUEST_FAIL,
  payload: error,
})

export const updateDocumentRequest = documentRequest => ({
  type: UPDATE_DOCUMENT_REQUEST,
  payload: documentRequest,
})

export const updateDocumentRequestSuccess = documentRequest => ({
  type: UPDATE_DOCUMENT_REQUEST_SUCCESS,
  payload: documentRequest,
})

export const updateDocumentRequestFail = error => ({
  type: UPDATE_DOCUMENT_REQUEST_FAIL,
  payload: error,
})

export const deleteDocumentRequest = data => ({
  type: DELETE_DOCUMENT_REQUEST,
  payload: data,
})

export const deleteDocumentRequestSuccess = data => ({
  type: DELETE_DOCUMENT_REQUEST_SUCCESS,
  payload: data,
})

export const deleteDocumentRequestFail = error => ({
  type: DELETE_DOCUMENT_REQUEST_FAIL,
  payload: error,
})

